import { render, staticRenderFns } from "./ChacterOverflow.vue?vue&type=template&id=6fca63d7&scoped=true&"
import script from "./ChacterOverflow.vue?vue&type=script&lang=js&"
export * from "./ChacterOverflow.vue?vue&type=script&lang=js&"
import style0 from "./ChacterOverflow.vue?vue&type=style&index=0&id=6fca63d7&lang=scss&scoped=true&"
import style1 from "./ChacterOverflow.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fca63d7",
  null
  
)

export default component.exports